// extracted by mini-css-extract-plugin
export default {"skipToContent":"SkipToContent-skipToContent-1g5"};